
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.99135 17.7768C9.68718 18.0744 9.19382 18.0744 8.88954 17.7768L0.976282 10.0388C0.830116 9.89586 0.748047 9.70208 0.748047 9.50001C0.748047 9.29794 0.830116 9.10415 0.976282 8.96128L8.88954 1.22316C9.19382 0.925613 9.68718 0.925613 9.99135 1.22316C10.2956 1.5207 10.2956 2.00313 9.99135 2.30067L3.40814 8.73812L19.9689 8.73812C20.3992 8.73812 20.748 9.07923 20.748 9.50001C20.748 9.92079 20.3992 10.2619 19.9689 10.2619L3.40814 10.2619L9.99135 16.6994C10.2956 16.9969 10.2956 17.4793 9.99135 17.7768Z","fill":"#8338EC"}})])
          )
        }
      }
    